import { useState, useEffect } from 'react';

export type ViewMode = 'list' | 'cards';

export const useViewMode = (defaultMode?: ViewMode) => {
  const [isMobile, setIsMobile] = useState(false);
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    // On mobile, always default to cards
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      return 'cards';
    }
    return defaultMode || 'list';
  });

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // Auto-switch to cards on mobile
      if (mobile) {
        setViewMode('cards');
      }
    };

    // Initial check
    checkMobile();

    // Listen for resize
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return {
    viewMode,
    setViewMode,
    isMobile
  };
};

